"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageViewId = exports.getSessionId = exports.getVisitorId = void 0;
const EventsToolkitSettings_1 = require("./EventsToolkitSettings");
const EventsToolkitUtilities_1 = require("./EventsToolkitUtilities");
const sessionIdCookieName = "session_id";
const visitorIdCookieName = "visitor_id";
const pageViewIdSessionStorageName = "page_view_id";
function getCookie(name) {
    var _a;
    let matches = (_a = document.cookie) === null || _a === void 0 ? void 0 : _a.match(new RegExp("(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
// this routine is based on various approaches that have been posted and discussed
// at https://gist.github.com/jed/982883
// we prefer to do "inline" uuid generation here instead of including a separate library.
const getUuid = (a = "") => {
    var _a;
    return a
        ? /* eslint-disable no-bitwise */
            (Number(a) ^
                (((_a = window.crypto) === null || _a === void 0 ? void 0 : _a.getRandomValues(new Uint8Array(1))[0]) &
                    (15 >> (Number(a) / 4)))).toString(16)
        : `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, getUuid);
};
function getVisitorId() {
    if ((0, EventsToolkitUtilities_1.isBrowser)()) {
        var visitorId = getCookie(visitorIdCookieName);
        if (!visitorId) {
            visitorId = getUuid();
            document.cookie =
                visitorIdCookieName +
                    "=" +
                    visitorId +
                    ";domain=" +
                    EventsToolkitSettings_1.settings.domain +
                    ";path=/;max-age=5897232000";
        }
        return visitorId;
    }
    else {
        return undefined;
    }
}
exports.getVisitorId = getVisitorId;
function getSessionId() {
    if ((0, EventsToolkitUtilities_1.isBrowser)()) {
        var sessionId = getCookie(sessionIdCookieName);
        if (!sessionId) {
            sessionId = getUuid();
        }
        // session id values should be regenerated after 60 minutes (3600 seconds) of inactivity
        document.cookie =
            sessionIdCookieName +
                "=" +
                sessionId +
                ";domain=" +
                EventsToolkitSettings_1.settings.domain +
                ";path=/;max-age=3600";
        return sessionId;
    }
    else {
        return undefined;
    }
}
exports.getSessionId = getSessionId;
function getPageViewId() {
    if ((0, EventsToolkitUtilities_1.isBrowser)()) {
        var pageViewIdSession = sessionStorage.getItem(pageViewIdSessionStorageName);
        var pageViewIdJson;
        var pageViewId;
        if (pageViewIdSession) {
            pageViewIdJson = JSON.parse(pageViewIdSession);
        }
        if (pageViewIdJson && pageViewIdJson.length == 2 && pageViewIdJson[0] == window.location.pathname) {
            pageViewId = pageViewIdJson[1];
        }
        else {
            pageViewId = getUuid();
            pageViewIdSession = JSON.stringify([location.pathname, pageViewId]);
            sessionStorage.setItem(pageViewIdSessionStorageName, pageViewIdSession);
        }
        return pageViewId;
    }
    else {
        return undefined;
    }
}
exports.getPageViewId = getPageViewId;
